import adminsTemplate from './admins.html';

export default angular
  .module('main.organizations.edit.tabs.admins', [])

  .directive('editOrganizationAdminsTab', () => {
    return {
      restrict: 'E',
      template: adminsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   $state,
                   utils,
                   ToastsService,
                   PermissionsService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');

        const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';

        const isAdminsEditor = PermissionsService.canIManageOrganizationAdmins();

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          adminsLoading: true,
          isAdminsListed: isAdminsListed,
          copyToClipboard: $rootScope.copyToClipboard,
          isUserEditable: isUserEditable,
          searchUser: searchUser,
          addAdmin: addAdmin,
          editUser: editUser,
          grantRole: grantRole,
          removeAdmin: removeAdmin,
          deleteAdminAndRole: deleteAdminAndRole,
        });

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#revoke-role-dialog').remove();
          $('#org-roles-modal').remove();
        });

        init();

        function init() {
          $scope.loading = true;

          // Prevent to load current tab if not enough permissions,
          // and drop to default organization 'contacts' tab
          if (!isAdminsEditor) {
            $scope.dataProvider.activeTab = 'contacts';
          }

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationAdminsResource.init(),
            $scope.dataProvider.adminRolesResource.init(),
            $scope.dataProvider.currentUserResource.init(),
            $scope.dataProvider.parentOrganizationResource.init(),
          ])
            .then(() => {
              initOrganizationAdmins();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
              $scope.adminsLoading = false;
            });
        }

        function initOrganizationAdmins() {
          $scope.admins = angular.copy($scope.dataProvider.organizationAdminsResource.value || []);
          $scope.roles = angular.copy($scope.dataProvider.adminRolesResource.value || []);
          $scope.currentUser = angular.copy($scope.dataProvider.currentUserResource.value?.user);
          $scope.adminsLoading = false;
        }

        function isAdminsListed() {
          return !$scope.loading && !$scope.adminsLoading && $scope.admins && $scope.admins.length > 0;
        }

        function grantRoleInternal() {
          return $scope.dataProvider.grantAdminRole($scope.selectedAdmin.id, $scope.selectedRoleId)
            .then(() => {
              $scope.selectedAdmin.role = $scope.selectedRole;
              ToastsService.success(null, $t('orgs.edit.role.assign-role-desc'));
            }).catch(err => handleError(err));
        }

        function grantRole(admin) {
          // NOTE: you can not change your own org role
          if (admin.id === $scope.currentUser.id) {
            return;
          }

          $scope.selectedAdmin = admin;
          $scope.selectedRoleId = admin.role ? admin.role.id : null;

          $scope.rolesForAdmin = $scope.roles.slice();
          if ($scope.selectedRoleId != null && !$scope.rolesForAdmin.some(role => role.id === $scope.selectedRoleId)) {
            $scope.rolesForAdmin.unshift({
              id: admin.role.id,
              name: admin.role.name || '',
              description: admin.role.description || '',
              permissions: admin.permission || [],
            });
            console.log('Added role ', $scope.rolesForAdmin[0]);
          }

          $('#org-roles-modal').modal({
            autofocus: false,
            closable: false,
            detachable: true,
            onApprove: grantRoleInternal
          }).modal('show');
        }

        function isUserEditable(user) {
          return PermissionsService.canIEditUser(user);
        }

        /**
         * Focus on the search users field,
         * and scroll down to that field
         */
        function searchUser() {
          $('#form-search-admin').form('clear');
          $('#input-admin-email').trigger('focus');
        }

        /**
         * Add selected user to the list of admins,
         * triggered as callback from the sub-component
         */
        function addAdmin(user) {
          return $scope.dataProvider.addUserToOrganizationAdmins(user.id)
            .then(() => {
              initOrganizationAdmins();
              ToastsService.success(null, $t('orgs.new.admins.addedDesc'));
            })
            .catch(err => handleError(err));
        }

        function editUser(user) {
          utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
          if (isUserEditable(user)) {
            $rootScope.$emit('refreshChooseMenuEvent', 'users');
            $state.go('main.users.edit', {
              from: 'organization',
              fromTab: $scope.dataProvider.activeTab
            });
          } else {
            $rootScope.$emit('refreshChooseMenuEvent', 'users');
            $state.go('main.users.view', {
              from: 'organization',
              fromTab: $scope.dataProvider.activeTab
            });
          }
        }

        /**
         * Removes admin from organization
         */
        function removeAdmin(user) {
          // NOTE: you can not remove yourself from org admins
          if (user.id === $scope.currentUser.id) {
            return;
          }

          // If user don't have permission 0 - show modal with "revoke and remove" option
          if (!(user.permission && user.permission.some(p => p === 0))) {
            $scope.selectedAdmin = user;
            $('#revoke-role-dialog').modal({
              autofocus: false,
              closable: false,
              detachable: true,
              onApprove: () => deleteAdminAndRole(user)
            }).modal('show');
            return;
          }
          return deleteAdminAndRole(user);
        }

        /**
         * Removes and admin and optionally revoke role
         */
        function deleteAdminAndRole(user, revoke) {
          return $scope.dataProvider.removeAdminFromOrganization(user.id)
            .then(() => {
              if (revoke) {
                $('#revoke-role-dialog').modal('hide');
                return $scope.dataProvider.revokeAdminRole(user.id)
                  .then(() => {
                    $scope.selectedAdmin = null;
                    let message = revoke ? $t('orgs.new.admins.revokeDesc') : $t('orgs.new.admins.removeDesc');
                    ToastsService.success(null, message);
                    return initOrganizationAdmins();
                  }, err => handleError(err));
              }
              return initOrganizationAdmins();
            }, err => handleError(err));
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          $scope.adminsLoading = false;
          return utils.handleApiError(err);
        }

      }
    };
  })
  .name;
